/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag jsx
 */
import { FormattedMessage, useIntl } from 'react-intl';

import { jsx } from '@atlaskit/css';
import { EmptyState } from '@atlassian/search-dialog/empty-state';

import { SearchErrorImage } from '../../../article-search-component/search-dropdown/resolved-and-error-content/error-image';
import { messages } from './messages';
import { SplitHelpObjectSearchResults } from './split-help-object-search-results';

type HelpObjectSearchResultsProps = {
	cloudId: string;
	helpCenterAri: string;
	queryWord: string;
};

export const HelpObjectSearchError = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<EmptyState
			title={formatMessage(messages.errorTitle)}
			Image={SearchErrorImage}
			content={<FormattedMessage {...messages.errorDescription} />}
		/>
	);
};

export const HelpObjectSearchResults = ({
	cloudId,
	helpCenterAri,
	queryWord,
}: HelpObjectSearchResultsProps): React.JSX.Element => {
	return (
		<SplitHelpObjectSearchResults
			key={`${cloudId}:${helpCenterAri}:${queryWord}`}
			cloudId={cloudId}
			helpCenterAri={helpCenterAri}
			queryWord={queryWord}
		/>
	);
};
